import api from '../../../App/socket';

const baseParams = {
    api: 'module',
    module: 'UserManagement',
    classMethod: 'ManageTransportUser',
};

export const getDriverRequest = (email) => api.send({
    ...baseParams,
    options: {
        method: 'getDriver',
        params: {
            email
        },
    },
});

export const createDriverRequest = ({email, password, userId}) => api.send({
    ...baseParams,
    options: {
        method: 'createDriver',
        params: {
            email,
            password,
            userId
        },
    },
});

export const updateDriverPasswordRequest = ({email, password}) => api.send({
    ...baseParams,
    options: {
        method: 'updateDriverPassword',
        params: {
            email,
            password
        },
    },
});


export const getCalendarUserRequest = (email) => api.send({
    ...baseParams,
    options: {
        method: 'getCalendarUser',
        params: {
            email
        },
    },
});

export const createCalendarUserRequest = ({email, password, userId, isAdmin}) => api.send({
    ...baseParams,
    options: {
        method: 'createCalendarUser',
        params: {
            email,
            password,
            userId,
            isAdmin
        },
    },
});

export const updateCalendarUserPasswordRequest = ({email, password}) => api.send({
    ...baseParams,
    options: {
        method: 'updateCalendarUserPassword',
        params: {
            email,
            password
        },
    },
});

export const updateCalendarAccessRequest = ({email, userId, isAdmin}) => api.send({
    ...baseParams,
    options: {
        method: 'updateCalendarAccess',
        params: {
            email,
            userId,
            isAdmin
        },
    },
});


// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/transport_user.requests.js